import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../../context/AuthContext";

type ProtectedRouteProps = {
  allowedRoles?: string[];
};

export default function ProtectedRoute({
  allowedRoles = [],
}: ProtectedRouteProps) {
  const { isAuthenticated, rol } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/" replace />;
  }

  if (allowedRoles.length > 0) {
    const normalizedRole = String(rol || "").toUpperCase();
    const isAllowed = allowedRoles
      .map((role) => role.toUpperCase())
      .includes(normalizedRole);

    if (!isAllowed) {
      return <Navigate to="/" replace />;
    }
  }

  return <Outlet />;
}